import React, { Fragment } from 'react';

import { Col, Container, Row } from 'reactstrap';
import InventoryMatTable from './components/InventoryMatTable';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { withRouter } from 'react-router-dom';
import TrialAlert from '../../shared/components/payment/TrialAlert';

import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission	} from "../../shared/helpers/access";

import {
  isMobile,
} from "react-device-detect";

const SEGMENT_TITLES = {
	condos: 'Condo & Co-op Units',
	houses: 'Single & Multi-Family Properties',
};

const SEGMENT_SUBHEADS = {
	condos: 'Search for Condo and Co-op Units by Location, Size, Price and More.',
	houses: 'Search for Houses by Location, Size, Price and More.',
};

const InventoryUnified = ( {user, match } ) => {
	const segment = match && match.params && match.params.segment ? match.params.segment : 'condos';
	const title = SEGMENT_TITLES[segment] || SEGMENT_TITLES['condos'];
	const subhead = SEGMENT_SUBHEADS[segment] || SEGMENT_SUBHEADS['condos'];

	return(
		<Container>
			<Row>
				<Col md={12}>
					<h3 className="page-title">{title}</h3>
					{!isMobile && <h3 className="page-subhead subhead">{subhead}</h3> }
				</Col>
			</Row>
			{_hasPermission(user, 'inventory-search') ?
				<Fragment>
					<Row>
						<Col md={12} className={'mb-3'}>
							<TrialAlert />
						</Col>
					</Row>
					<Row>
						<InventoryMatTable segment={segment} />
					</Row>
				</Fragment>
				:
				<Row>
					<EnterpriseGate />
				</Row>
			}
		</Container>
	)
};


export default connect(state => ({
  user: state.user,
}))(withOktaAuth(withRouter(InventoryUnified)));
